import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
// import mixpanel from 'mixpanel-browser'

import { Mutations } from 'api/mutations.enum'
import { getPulseSurveyCSVDownload } from 'api/actions/pulseSurveys/pulseSurveysActions'
import { GetPulseSurveyCSVDownloadParams } from 'api/actions/pulseSurveys/pulseSurveysActions.types'
// import TAXONOMIES from 'utils/taxonomies'

interface UseDownloadPulseSurveyCSVReturn {
    handleDownloadCSV: () => void
    isDownloading: boolean
}

export const useDownloadPulseSurveyCSV = (params: GetPulseSurveyCSVDownloadParams): UseDownloadPulseSurveyCSVReturn => {
    const mutation = useMutation<void, AxiosError, GetPulseSurveyCSVDownloadParams>({
        mutationFn: () => {
            return getPulseSurveyCSVDownload(params)
        },
        mutationKey: [Mutations.downloadPulseSurveyCSV, params.surveyUUID],
        onSuccess: () => {
            // Track the download (optional)
            // mixpanel.track(TAXONOMIES.PULSE_SURVEY_CSV_DOWNLOAD || 'Pulse Survey CSV Download')
        },
    })

    const handleDownloadCSV = () => {
        if (!params.surveyUUID) return
        mutation.mutate({ ...params })
    }

    return {
        handleDownloadCSV,
        isDownloading: mutation.isLoading,
    }
}
